import React from "react"
import "react-app-polyfill/stable"
import ReactDOM from "react-dom"
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom"

import { AccountProvider } from "@shared/contexts"

import ChattingTerms from "live/components/sidebar/contents/ChattingTerms"
import { SnackbarProvider } from "notistack"
import { StreamerHotkeysPage } from "Pages"

import App from "./App"
import * as serviceWorker from "./serviceWorker"

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route
        path="/playground"
        component={() => <ChattingTerms onClose={() => {}} />}
      />
      <Route
        exact
        path="/:streamerName/:scheduleId/streamer-hotkeys"
        component={StreamerHotkeysPage}
      />
      <Route
        path="/:streamerName/:scheduleId"
        component={() => (
          <AccountProvider>
            <SnackbarProvider>
              <App />
            </SnackbarProvider>
          </AccountProvider>
        )}
      />
      <Redirect from="*" to="/not-found" />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root"),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
